<template>
<div id="catalogos_errores">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="mdi-account" title="Administrar Traducción de Errores" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer />

            <v-btn fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>
                
                <template slot="actions" slot-scope="props">
                  <v-btn x-small fab dark color="success" @click.native="editar(props.row.uuid)" title="Editar Error" v-tippy>
                    <v-icon>edit</v-icon>
                  </v-btn>&nbsp;
                  <v-btn x-small fab dark color="pink" @click.native="eliminar(props.row.uuid)" title="Eliminar Error" v-tippy>
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="modal" max-width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">{{ tituloModal }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" autocomplete="off">
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="model.error" label="Error" :rules="[this.$rules.required]" class="input-group--focused secure" 
                      hint="Parte principal del error que regresa el Webservice"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="model.descripcion" label="Descripción" :rules="[this.$rules.required]"
                    hint="Descripción simple del error para los usuarios"
                    ></v-text-field>
                  </v-col>
                 
                </v-row>
                
              </v-card-text>
            </v-card>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" small @click="modal=false">
          <v-icon small>mdi-cancel</v-icon> Cancelar
        </v-btn>
        <v-btn color="success" small @click="guardar">
          <v-icon small>mdi-check-circle-outline</v-icon> Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import moment from "moment";

export default {
  created: function() {
    this.URL = this.$hostname + "carta_porte/administracion/";       
    this.model = this.clean_model();    
    this.cargar();
  },
  computed: {
    tituloModal() {
      return this.updateModel === false ? "Nuevo Error" : "Editar Error";
    },    
  },
  data: () => ({
    URL:"",
    tabla: "errores_webservice",
    show1: false,
    show2: false,
    modal: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Errores Webservice",
        disabled: true,
        href: "",
      },
    ],
    model: {},
    updateModel: false,
    columns: ["error", "descripcion", "actions"],
    options: {
      filterable: true,
      headings: {
        error: "Error Webservice",
        descripcion: "Descripción Simple",
        actions: "Operaciones"
      }
    },
    items: [],    
  }),
  methods: {
    cargar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      
      var self = this;
      this.$axios.post(this.URL+"list_errores/")
          .then(res => {
              self.items = res.data;
          })
          .catch(err => {
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener los registros.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{              
              self.$root.$dialogLoader.hide();
          });      
    },
    agregar: function() {
      this.model = this.clean_model();
      this.updateModel = false;
      this.modal = true;      
    },
    editar: function(id) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      this.model = this.clean_model();
      var params = {
        filtros: {
          uuid: id,
        },
      };
      this.$axios.post(this.URL+"list_errores/", params)
          .then(res => {
              if(res.data != null){
                  self.model = res.data[0];              
              }                
          })
          .catch(err => {
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener el registro.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{       
              this.modal = true;
              this.updateModel = true;       
              self.$root.$dialogLoader.hide();
          });
      
    },
    
    eliminar: function (id) {      
      var self = this;
      self.$swal({
          type: "info",
          title: "Cuidado",
          text: "¿Está seguro de eliminar el registro?",
          footer: "",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
      }).then(result => {
          if (result.value){
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var params = {              
                uuid: id,              
            };
            this.$axios.post(this.URL + "delete_error/", params)
              .then(res => {
                  self.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El registro se eliminó correctamente.",
                    footer: "",
                  });
                  self.cargar();
              })
              .catch(err => {                        
                  this.$swal({
                      type: "error",
                      title: "Error",
                      text: "Ocurrió un error al eliminar el registro.",
                      footer: "",
                  });
                  console.log(err);
              }).then(()=>{
                  self.$root.$dialogLoader.hide();
              });  
                         
          }
      });
      
    }, 
    guardar: function() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        if (this.updateModel === false) {
          this.model.uuid = this.$uuid.v4();
          
          var self = this;
          var search = {
            filtros:{
              error: {"$regex": self.model.error, "$options": 'i'}
            }            
          };

          this.$axios.post(this.URL+"list_errores/", search)
          .then(res => {
            
            if (typeof res.data !== "undefined" && res.data.length > 0) {
                self.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ya existe un registro con ese error.",
                  footer: "",
                });
                self.$root.$dialogLoader.hide();                
              } else {                

                this.$axios.post(this.URL + "create_error/", self.model)
                .then(res => {
                    self.$swal({
                      type: "success",
                      title: "¡Operación Exitosa!",
                      text: "El registro se guardó correctamente.",
                      footer: "",
                    });       
                    self.modal = false;             
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.$root.$dialogLoader.hide(); 
                    self.cargar();
                }); 
                                
              }
          })
          .catch(err => {
            self.$root.$dialogLoader.hide();
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al guardar el registro.",
                  footer: "",
              });
              console.log(err);
          });
          

        } else {
          var self = this;
          this.$axios.post(this.URL + "update_error/", self.model)
                .then(res => {
                    self.$swal({
                      type: "success",
                      title: "¡Operación Exitosa!",
                      text: "El registro se guardó correctamente.",
                      footer: "",
                    });
                    self.modal = false;                    
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.$root.$dialogLoader.hide();
                    self.cargar();
                    
                }); 
          
        }        
        
      }
    },
    
    
    clean_model: function() {
      return {
        uuid:"",
        error: "",
        descripcion: ""        
      };
    }
  },
};
</script>
<style scoped>

.VueTables>>>tbody td {
    white-space: normal !important;
}
</style>